import React from 'react'
import { RxCross1 } from 'react-icons/rx'

const WhatIsThis = ({ close }) => {
  return (
    <div className='what-is-this-container'>
      <div className='what-is-this-section'>
        <button className='close' onClick={() => close(false)}>
          <RxCross1 size={10} />
        </button>
        <p>
          Ask Arrowhead a question pertaining to anything you have discussed in
          your meetings since you’ve started using Arrowhead.
        </p>
        <ul>
          <li>Examples:</li>
          <li>
            - Overall: What are this person’s pending action items? Where are we
            on this sprint?
          </li>
          <li>
            - Investor calls: What are the common questions investors are
            asking?
          </li>
          <li>
            {
              '- User calls: What are the biggest pain points users have in [name the problem you’re solving for]?'
            }
          </li>
          <li>- Project mgmt: What are the main blockers in Project X?</li>
        </ul>
      </div>
    </div>
  )
}

export default WhatIsThis
